import { Link } from "widgets-for-react"
import React from "react"
import { getTargetBlankProps } from "../../../EntryPoint/Frontend/cms/utils/link"

//  This function matches the url of a DrupalLink against a regex that checks if the url that we want to
//  navigat to is on the same host we are curently at, or is only a path so we can use the <Link> component
//  otherwhise, if it isnt a url on our own hostname it returns true and is external.
export type LinkProps = {
  kind: "link"
  target: "_blank" | "_self"
  url: string
  title: string
  anchor?: string
}

const isLinkExternal = (link: string): boolean => {
  // debugger
  if (link && link != '' && !link.startsWith('/')) {
    let currentUrlHost = window.location.host

    if ((link.toLowerCase().includes("https://") || link.toLowerCase().includes("http://")) && new URL(link).host != currentUrlHost) {
      return true;
    }

    return false;

    // let pattern = RegExp(`(http|https:\/\/(!?${currentUrlHost}/.*)|^\/.*)`, "gm");
    // const isExternal = !pattern.test(link);
    // return isExternal;
  } else {
    return false
  }
}

export const stripUrlToPath = (link: { title: string, url: string }): string => {
  let a = document.createElement("a")
  a.href = link.url
  return a.pathname
}

export const linkWrapper = (rawLink: { title: string, url: string }): LinkProps => {
  const path = rawLink.url && stripUrlToPath(rawLink)
  const link = path.startsWith("/sites/") || isLinkExternal(rawLink.url) ? rawLink : { ...rawLink, url: path }
  return ({
    kind: "link",
    target: isLinkExternal(link.url) ? "_blank" : "_self",
    title: link.title,
    url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link),
  })
}

export function LinkLayout(p: {
  link: LinkProps,
  className: string,
  children: React.ReactNode,
  onClick?: () => void
  onMouseEnter?: () => void
  onFocus?: () => void
  onBlur?: () => void
  id?: string,
}): JSX.Element {
  return isLinkExternal(p.link.url) || p.link.target === '_blank' ? (
    <a
      href={`${p.link.url}${p.link.anchor ? `#${p.link.anchor}` : ''}`}
      // title={p.link.title}
      className={p.className}
      target={p.link.target}
      {...(p.link.target === '_blank' ? getTargetBlankProps(p.link.url) : {})}
      onClick={p.onClick || undefined}
      onMouseEnter={p.onMouseEnter || undefined}
      onFocus={p.onFocus || undefined}
      onBlur={p.onBlur || undefined}
      id={p.id}
    >
      {p.children}
    </a>
  ) : (
    <Link
      to={`${p.link.url}${p.link.anchor ? `#${p.link.anchor}` : ''}`}
      // title={p.link.title}
      className={p.className}
      onClick={p.onClick || undefined}
      onMouseEnter={p.onMouseEnter || undefined}
      onFocus={p.onFocus || undefined}
      onBlur={p.onBlur || undefined}
      id={p.id}
    >
      {p.children}
    </Link>
  )
}
